var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.66089V8.91591M15.5 6.80536V3.77144C15.5 3.03268 15.5 2.6633 15.3365 2.38113C15.1927 2.13292 14.9633 1.93113 14.681 1.80466C14.3602 1.66089 13.9401 1.66089 13.1 1.66089H5.08855C3.99244 1.66089 3.44438 1.66089 3.00173 1.83727C2.61159 1.99273 2.28001 2.24289 2.04597 2.55835C1.78042 2.91627 1.69708 3.39262 1.53041 4.34533L1.1381 6.58779C0.918273 7.84435 0.808358 8.47263 1.02039 8.9615C1.2065 9.39058 1.55653 9.74938 2.01048 9.97638C2.52769 10.235 3.25054 10.235 4.69624 10.235H5.30004C5.72008 10.235 5.9301 10.235 6.09053 10.3069C6.23165 10.3701 6.34639 10.471 6.41829 10.5951C6.50004 10.7362 6.50004 10.9209 6.50004 11.2903V13.2255C6.50004 14.1237 7.32804 14.8518 8.34942 14.8518C8.59304 14.8518 8.8138 14.7257 8.91275 14.5299L11.4333 9.5426C11.548 9.31576 11.6053 9.20234 11.6959 9.11918C11.776 9.04566 11.8743 8.98945 11.9833 8.95495C12.1065 8.91591 12.2476 8.91591 12.5299 8.91591H13.1C13.9401 8.91591 14.3602 8.91591 14.681 8.77214C14.9633 8.64567 15.1927 8.44388 15.3365 8.19567C15.5 7.9135 15.5 7.54412 15.5 6.80536Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.bd5d3683665c48e3af11a98ba5518c61.svg";
export { ForwardRef as ReactComponent };